module.exports = __webpack_public_path__ + "static/media/Icon - add source.9be4ffd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - add source.svg
// module id = 70
// module chunks = 0